function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import chroma from 'chroma-js';
import color from './color';
var white = color.white,
    grey800 = color.grey800; // Structuring colors here so colors can be accessed semantically with `categorical`
// or as an ordered list with `series` for Chart component.

var categoricalData = [['cobalt', '#4778C2'], ['cider', '#CC7830'], ['plum', '#9E54C0'], ['aqua', '#339699'], ['slate', '#66728F'], ['rose', '#D367BD'], ['olive', '#6D7C4D'], ['salmon', '#DD6367'], ['indigo', '#7868CE'], ['jade', '#17A67B'], ['sky', '#3289C8'], ['autumn', '#BE5408'], ['lavender', '#A478A5'], ['ocean', '#007C8F'], ['smoke', '#84878E'], ['fuchsia', '#C24795'], ['lime', '#7C981A'], ['brick', '#BA483F'], ['violet', '#6E79CF'], ['forest', '#23835D']];
export var categorical = categoricalData.reduce(function (obj, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      hex = _ref2[1];

  obj[name] = hex;
  return obj;
}, {});
export var series = categoricalData.map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      hex = _ref4[1];

  return hex;
});
export var createColorInterpolator = function createColorInterpolator(colors) {
  var scale = chroma.scale(colors);
  return function (value) {
    return scale(value).css();
  };
};
export var createColorGradient = function createColorGradient(colors, numColors) {
  return chroma.scale(colors).colors(numColors);
};
var cobalt = categorical.cobalt,
    plum = categorical.plum,
    aqua = categorical.aqua,
    salmon = categorical.salmon,
    forest = categorical.forest,
    sky = categorical.sky,
    lavender = categorical.lavender,
    ocean = categorical.ocean,
    brick = categorical.brick,
    jade = categorical.jade;
export var sequential = {
  lightTeal5: createColorGradient([white, aqua], 5),
  lightTeal6: createColorGradient([white, aqua], 6),
  lightBlue5: createColorGradient([white, sky], 5),
  lightBlue6: createColorGradient([white, sky], 6),
  lightRed5: createColorGradient([white, salmon], 5),
  lightRed6: createColorGradient([white, salmon], 6),
  darkTeal5: createColorGradient([grey800, ocean], 5),
  darkTeal6: createColorGradient([grey800, ocean], 6),
  darkBlue5: createColorGradient([grey800, cobalt], 5),
  darkBlue6: createColorGradient([grey800, cobalt], 6),
  darkRed5: createColorGradient([grey800, brick], 5),
  darkRed6: createColorGradient([grey800, brick], 6)
};
export var diverging = {
  lightRedBlue7: createColorGradient([salmon, white, sky], 7),
  lightRedBlue9: createColorGradient([salmon, white, sky], 9),
  lightRedGreen7: createColorGradient([salmon, white, jade], 7),
  lightRedGreen9: createColorGradient([salmon, white, jade], 9),
  lightPurpleTeal7: createColorGradient([lavender, white, aqua], 7),
  lightPurpleTeal9: createColorGradient([lavender, white, aqua], 9),
  darkRedBlue7: createColorGradient([brick, grey800, cobalt], 7),
  darkRedBlue9: createColorGradient([brick, grey800, cobalt], 9),
  darkRedGreen7: createColorGradient([brick, grey800, forest], 7),
  darkRedGreen9: createColorGradient([brick, grey800, forest], 9),
  darkPurpleTeal7: createColorGradient([plum, grey800, ocean], 7),
  darkPurpleTeal9: createColorGradient([plum, grey800, ocean], 9)
};